import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import { styled } from "@mui/material";
import * as React from "react";

type Colors =
    | MprcColors
    | "white"
    | "black"
    | "inherit"
    | "transparent";

interface IProps {
    icon: IconProp;
    color?: Colors;
}

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)
    <{ color: Colors; }>(({ theme, color }) => (
        {
            color: color == "white" || color == "black"
                ? theme.palette.common[color]
                : color == "inherit"
                    ? "inherit"
                    : color == "transparent"
                        ? "transparent"
                        : theme.palette[color!].main
        }));


export type MprcIconFaProps = Omit<FontAwesomeIconProps, "color" | "icon"> & IProps;

export const MprcIconFa: React.FC<MprcIconFaProps> = (props) => {
    const { icon, color = "inherit", ...rest } = props;
    return (
        <StyledFontAwesomeIcon
            {...rest}
            color={color!}
            icon={icon}
        />
    );
};
